/**
 * Forget the last account's data held in memory when the signed-in account changes.
 *
 * ⚠️⚠️ A SIGN-OUT DOES NOT RELOAD THE PAGE. A store without `persist` keeps what it
 * loaded until its next load, so the next person to sign in on this device would see
 * the last one's data on their first render. A store whose data must not outlive the
 * account registers its reset here; `authStore` runs them all whenever the signed-in
 * account changes — a sign-out by any route, or another account signing in.
 *
 * ⚠️ Registered when the store's module loads, so a store whose chunk never loaded is
 * not called — it has nothing to forget.
 */

const resets = new Set<() => void>();

/** Register a reset. Returns the unregister (tests). */
export function onSignOut(reset: () => void): () => void {
  resets.add(reset);
  return () => { resets.delete(reset); };
}

/** Run every registered reset. One that throws never stops the others. */
export function forgetSignedOutAccount(): void {
  for (const reset of resets) {
    try {
      reset();
    } catch (err) {
      console.error('Sign-out reset failed:', err);
    }
  }
}
